import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  sectionContainer: { gap: theme.spacing(2), width: '100%', margin: theme.spacing(4) },
  sectionHeader: { width: '100%' },
  questionsCard: {
    padding: theme.spacing(8),
    width: '100%',
    backgroundColor: theme.colorPalette.beige_25
  },
  questionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 0),
    '&:not(:first-child)': {
      borderTop: `1px solid ${theme.colorPalette.beige_50}`
    }
  },
  questionText: {
    display: 'flex'
  },
  radioContainer: {
    gap: theme.spacing(2)
  },
  detailsField: {
    margin: `${theme.spacing(4, 0)} !important`,
    width: '100%'
  }
});

export default makeStyles(styles);
